import React, { useEffect, useState } from 'react';
import MuxPlayer from '@mux/mux-player-react';
import { API_SOCIAL } from '../../../constants/api';
import request from '../../../utils/api';
import Subtitle from '../../core/Subtitle/index';

const EventPlayer4 = () => {
  const [image, setImage] = useState();
  const [logo, setLogo] = useState();
  const [url, setUrl] = useState();

  const [image2, setImage2] = useState();
  const [logo2, setLogo2] = useState();
  const [url2, setUrl2] = useState();
  useEffect(() => {
    request(`${API_SOCIAL}widget/home`, {
      params: '',
      method: 'GET'
    }).then(response => {
      response.map(el => {
        if (el.type === 'player2') {
          setImage(el.icon);
          setLogo(el.logo);
          setUrl(el.url);
        } else if (el.type === 'player4') {
          setImage2(el.icon);
          setLogo2(el.logo);
          setUrl2(el.url);
        }
        return image;
      });
    });
  }, []);
  return (
    <div>
      <Subtitle>{url}</Subtitle>
      <MuxPlayer
        streamType="on-demand"
        playbackId={image}
        poster={logo}
        style={{ height: '23em' }}
      />
      <Subtitle>{url2}</Subtitle>
      <MuxPlayer
        streamType="on-demand"
        playbackId={image2}
        poster={logo2}
        style={{ height: '23em' }}
      />
    </div>
  );
};

export default EventPlayer4;
